import axios from "axios";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import urls from "../urls";
import { showError, showSuccess } from "../utils/notifications";

const ServiceApplicationModal = ({ show, onClose, status }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [serviceDetails, setServiceDetails] = useState("");
  const { uuid, faculty_id } = useSelector((state) => state.userState);
  const handleaddNewApplication = async () => {
    if (serviceDetails.length < 15) {
      showError("طلب الخدمة لا ينبغي ان يقل على 15 حرف");
      return;
    }
    setIsLoading(true);
    axios
      .post(urls.requestService, {
        service: [uuid, serviceDetails, faculty_id],
      })
      .then((res) => {
        showSuccess("تمّ إرسال الطلب ");
        setServiceDetails("");
        setTimeout(() => setIsLoading(false), 3000);
        onClose();
      })
      .catch((err) => {
        showError("لم تتم عملية ارسال الطلب بنجاح !");
        setIsLoading(false);
        console.log(err);
      });
  };
  return (
    <>
      {/* React Bootstrap Modal */}
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header closeButton={!isLoading}>
          <Modal.Title style={{ fontSize: "13px" }}>طلب خدمة </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-floating">
            <textarea
              className="form-control"
              placeholder="Leave a comment here"
              id="floatingTextarea"
              style={{ height: "200px" }}
              value={serviceDetails}
              onChange={(e) => setServiceDetails(e.target.value)}
            ></textarea>
            <label htmlFor="floatingTextarea">تفاصيل الخدمة </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleaddNewApplication}
            disabled={isLoading}
          >
            {!isLoading ? (
              <span>إرسال الطلب</span>
            ) : (
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </Button>
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ServiceApplicationModal;
